import { USER_ROLE_LABEL_MAP, type UserRole } from '@/models/features/user.models'

export const getUserRoleLabel = (role: string): string =>
  USER_ROLE_LABEL_MAP[role as UserRole] ?? role
